import { motion } from "framer-motion";
import { NEWS } from "@/data";
import { ArrowRight } from "lucide-react";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export default function News() {
  return (
    <section id="news" data-testid="news-section" className="py-20 md:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <div className="font-mono-accent text-xs uppercase tracking-[0.2em] text-accent mb-4">// Νέα & Ανακοινώσεις</div>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-tight">
            Τι συμβαίνει στη Φυσική Επιλογή.
          </h2>
        </div>

        <div className="border-t border-border">
          {NEWS.map((n, i) => (
            <motion.article
              key={i}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.06 }}
              data-testid={`news-item-${i}`}
              className="group grid md:grid-cols-12 gap-4 md:gap-8 items-start py-8 border-b border-border hover:bg-secondary/40 transition-colors px-2 md:px-4 cursor-default"
            >
              <div className="md:col-span-3 flex items-center gap-3">
                <span className="font-mono-accent text-xs text-muted-foreground tracking-wider">{n.date}</span>
                <span className="font-mono-accent text-[10px] uppercase tracking-widest bg-primary/10 text-primary px-2 py-1 rounded-sm">
                  {n.tag}
                </span>
              </div>
              <div className="md:col-span-8">
                <h3 className="font-heading font-bold text-lg group-hover:text-primary transition-colors">{n.title}</h3>
                <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{n.desc}</p>
              </div>
              <div className="md:col-span-1 hidden md:flex justify-end">
                <ArrowRight className="h-5 w-5 text-muted-foreground opacity-0 group-hover:opacity-100 group-hover:text-primary transition-all -translate-x-2 group-hover:translate-x-0" />
              </div>
            </motion.article>
          ))}
        </div>

        <button
          data-testid="news-cta"
          onClick={() => scrollTo("contact")}
          className="mt-10 font-mono-accent text-xs uppercase tracking-widest text-primary hover:text-accent transition-colors"
        >
          Μάθετε περισσότερα → Επικοινωνήστε μαζί μας
        </button>
      </div>
    </section>
  );
}
